
import HelloImage from "@/assets/images/candidate/hello-img.png";
import { Component, Prop, Vue } from "vue-property-decorator";

const ICONS = {
  close: "close",
};

@Component
export default class HelloMessage extends Vue {
  @Prop({ type: Boolean, default: false }) readonly fromHomePage!: boolean;

  icons = ICONS;

  backgroundImage = HelloImage;

  get description() {
    return this.fromHomePage ? this.$tc("text.sponsor.have") : this.$tc("text.sponsor.not");
  }

  get imageStyleBackground() {
    return `backgroundImage: url(${this.backgroundImage})`;
  }
}
